import React, { FC, ReactNode } from 'react'

import styles from './styles.module.css'

export interface AccordionPanelProps {
  isOpen: boolean
  children: ReactNode
  isBottomAligned?: boolean
}

const AccordionPanel: FC<AccordionPanelProps> = ({ isOpen, children, isBottomAligned = false }) => (
  <div className={styles.panel} data-is-open={isOpen} data-is-bottom-aligned={isBottomAligned}>
    {children}
  </div>
)

export default AccordionPanel
